/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderCornerRounded = createReactComponent("outline", "border-corner-rounded", "IconBorderCornerRounded", [["path", { "d": "M4 20v-10a6 6 0 0 1 6 -6h10", "key": "svg-0" }]]);

export { IconBorderCornerRounded as default };
//# sourceMappingURL=IconBorderCornerRounded.mjs.map
